export const PATH_CLIENT = '/client';
export const PATH_ORGANIZATION = '/organization/:organizationId';
export const PATH_VICTIME = `${PATH_CLIENT}/:victimeId`;
export const PATH_PROCEDURE = '/procedures/:procedureId';
export const FULL_PATH_PROCEDURE = `${PATH_VICTIME}${PATH_PROCEDURE}`;
export const PATH_PREJUDICES = `${PATH_PROCEDURE}/prejudices`;
export const FULL_PATH_PREJUDICES = `${PATH_VICTIME}${PATH_PREJUDICES}`;
